




import Vue from 'vue'

export default Vue.extend({
  props: {
    correct: {
      type: Boolean as Prop<boolean>,
      default: false
    },
    size: {
      type: Number as Prop<number>,
      default: 27
    }
  },

  computed: {
    style (): any {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`
      }
    }
  }
})
